"use client";

import { useState, useEffect } from "react";
import { useParams } from "@/hooks";
import { AppDispatch } from "@/store";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPlans,
  createPlans,
  updatePlans,
  deletePlans,
} from "@/store/modules/plans/thunks";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { planSchema } from "@/validations";
import { InferType } from "yup";
import { useAuth } from "@/context/AuthContext";

const usePlan = (onSuccess?: () => void) => {
  const { params, setParams, handlePage } = useParams();
  const { establishment, baseURL } = useAuth();
  const { per_page, current_page } = params;

  // const {
  //   register,
  //   handleSubmit,
  //   reset,
  //   getValues,
  //   watch,
  //   control,
  //   formState: { errors, isSubmitting },
  // } = useForm({
  //   resolver: yupResolver(planSchema),
  //   defaultValues: {
  //     name: '',
  //     category_id: null,
  //     payment_method_id: '',
  //     limit: null,
  //     days: [],
  //     value: null,
  //     change_existing_registration_price: false,
  //     description: '',
  //     service: []
  //   },
  // });

  // const setFormData = (data: Partial<typeof planSchema.__outputType>) => {
  //   reset(data);
  // };

  // useEffect(() => {
  //   const sub = watch((values) => {
  //     console.log("Valores do formulário:", values);
  //   });
  //   return () => sub.unsubscribe();
  // }, [watch]);

  const dispatch: AppDispatch = useDispatch();
  const [planId, setPlanId] = useState<any>(null);

  // const onSubmit = async (data: Partial<typeof planSchema.__outputType>) => {
  //   try {
  //     let result;

  //     const transformedDays = (data.days ?? []).map((day: any) => ({
  //       name: day.label,
  //       day_id: parseInt(day.value),
  //     }));

  //     const payload = {
  //       ...data,
  //       days: JSON.stringify(transformedDays),
  //     };

  //     console.log('Payload enviado:', payload);

  //     if (planId) {
  //       result = await dispatch(updatePlans({ id: planId, ...payload }));
  //     } else {
  //       result = await dispatch(createPlans(payload));
  //     }

  //     if (
  //       createPlans.fulfilled.match(result) ||
  //       updatePlans.fulfilled.match(result)
  //     ) {
  //       if (onSuccess) onSuccess();
  //       dispatch(fetchPlans(params));
  //       reset();
  //       setPlanId(null);
  //     }

  //   } catch (error) {
  //     console.error("Erro ao enviar dados do plano:", error);
  //   }
  // };

  const plans = useSelector((state: any) => state.plans.plans.data);
  const loading = useSelector((state: any) => state.plans.loading);
  const error = useSelector((state: any) => state.plans.error);

  useEffect(() => {
    // Aguarda baseURL estar pronto antes de fazer requests (não exigir establishment para admins)
    if (!baseURL) return;

    dispatch(fetchPlans(params));
  }, [baseURL, dispatch, params]);

  const handleDelete = async () => {
    try {
      if (planId) {
        await dispatch(deletePlans(planId));
        setPlanId(null);
        return true;
      }
    } catch (error) {
      console.error("Erro ao excluir plano:", error);
    }
  };

  return {
    // register,
    // handleSubmit,
    //onSubmit,
    // reset,
    // errors,
    // isSubmitting,
    plans,
    loading,
    error,
    setPlanId,
    handleDelete,
    // setFormData,
    // getValues,
    // control,
  };
};

export default usePlan;
